import React from 'react'

const Skills = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="30"
    viewBox="0 0 27 30"
  >
    <g>
      <g>
        <g>
          <path
            fill="#3a3a3a"
            d="M9.58 8h2.701c.475-.918-.244-2-1.351-2-1.105 0-1.828 1.08-1.35 2z"
          />
        </g>
        <g>
          <path
            fill="#3a3a3a"
            d="M10.43 4.054c2.265 0 3.963 1.916 3.472 3.946h4.528V6.216c0-.298-.265-.54-.593-.54h-1.196a5.583 5.583 0 0 0-.562-1.238l.846-.772a.508.508 0 0 0 0-.764l-1.676-1.53a.634.634 0 0 0-.838 0l-.847.773a6.777 6.777 0 0 0-1.356-.514V.541c0-.299-.266-.541-.593-.541h-2.37c-.327 0-.593.242-.593.54v1.092a6.773 6.773 0 0 0-1.356.513l-.847-.772a.634.634 0 0 0-.838 0L3.935 2.902a.508.508 0 0 0 0 .764l.846.772a5.583 5.583 0 0 0-.562 1.238H3.023c-.328 0-.593.242-.593.54V8h4.53c-.494-2.035 1.21-3.946 3.47-3.946z"
          />
        </g>
        <g>
          <path
            fill="#3a3a3a"
            d="M26.28 18.363l-3.47-5.271A10.799 10.799 0 0 0 22.181 10H1.078c-1.99 5.492.732 11.824 6.426 13.877v5.225c0 .496.396.898.884.898h10.078a.892.892 0 0 0 .885-.898V24.49h2.593a.892.892 0 0 0 .884-.898V19.76h2.717c.705 0 1.127-.8.735-1.397z"
          />
        </g>
      </g>
    </g>
  </svg>
)

export default Skills
